import { Show } from 'solid-js'
import { m } from '~/paraglide/messages'
import { CakeBoxIcon } from './icon/cake-box'
import { FlourishIcon } from './icon/flourish'

/** Tail item of the card rail once the event has ended. Same width and snap
 *  behavior as a day card but no card chrome — the message floats on the
 *  page background. Copy varies on whether claimable boxes remain. */
export function EventEndedPanel(props: { hasUnclaimedBoxes: boolean }) {
  return (
    <section class="flex min-h-[220px] w-[clamp(280px,calc(100vw-72px),350px)] flex-col items-center justify-center gap-2 px-6 text-center">
      <Show
        when={props.hasUnclaimedBoxes}
        fallback={
          <>
            <h2 class="text-base font-bold leading-6 text-white">
              {m.birthday_event_ended_title()}
            </h2>
            <p class="text-sm leading-5 text-bakery-cream">
              {m.birthday_event_ended_description()}
            </p>
            <FlourishIcon class="mt-6 w-[38px] text-bakery-cream" />
          </>
        }
      >
        <CakeBoxIcon class="mb-1 size-10" />
        <h2 class="text-base font-bold leading-6 text-white">
          {m.birthday_event_ended_boxes_waiting_title()}
        </h2>
        <p class="text-sm leading-5 text-bakery-cream">
          {m.birthday_event_ended_boxes_waiting_description()}
        </p>
      </Show>
    </section>
  )
}
